import { useEffect, useState } from "react";
import './Platform.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
import { useLocation } from "react-router-dom";
import BetaWaitlist from "../../Component/Beta-Waitlist/BetaWaitlist";
import Getstarted from "../../Component/GetStarted/Getstarted";
import PlatformPageSlide from "../../Component/PlatformPageSlide/PlatformPageSlide";

const Platform = () => {

    const [showWaitlist, setShowWaitlist] = useState(false);
    const [showGetstarted, setShowGetstared] = useState(false);
    //const navigate = useNavigate();
    const location = useLocation();

       // Function to handle navigation
      /* const handleNavigation = (section) => {
        if (location.pathname !== "/") {
            navigate("/", { state: { scrollTo: section } });
        } else {
            scrollToSection(section);
        }
    };*/

     // Function to scroll to section
     const scrollToSection = (section) => {
        setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300);
    };

       
       useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);


    return (
        <>
            <AIheader/>

            <Getstarted
            showJoinWaitList={showGetstarted}
            onClose={() => setShowGetstared(false)}
            onOpen={() => setShowGetstared(true)}
                />

            {/* START platformBannerMain */}
            <section className='platformBannerMain'>
                <div className='platformBannerOuter'>
                    <div className='container-fluid'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='platformBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="platform"/> Platform</h1>
                                    <h2>Made for car rental, designed for operators.</h2>
                                    <p>AI-powered automation, seamless renter interactions, fleet protection, 
                                    and guest support—everything you need, all in one place.</p>
                                    {/* <a className="btn btnPurple" href="/">Get started <img className='img-fluid' src="/img/arrow-right-white.svg" alt="rent id"/></a> */}
                                    {/* <JoinPriorityWaitlistBtn buttonclass="btn btnPurple" buttonText="Get started" buttonIcon="/img/arrow-right-white.svg" /> */}
                                    <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                />

                            <button onClick={() => setShowGetstared(true)} className="btn btnPurple">
                            Get started <img src='/img/arrow-right-white.svg' alt='Get started' />
                            </button>
                                    <h5>From on-board to on-rent in less than 60 minutes</h5>
                                </div>
                                <div className='platformBannerImage'>
                                    <img className='img-fluid' src="/img/Platform/banner_platform.png" alt="banner"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END platformBannerMain */}
 

            <PlatformPageSlide/>
            {/* START platformPageSlideMain */}
            <section className="platformPageSlideMain" style={{ display: 'none' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="platformPageHead">
                                <h2>Built for businesses <br/>across any industry</h2>
                            </div>
                        </div>
                    </div>
                </div> 
                <div className="platformPageSlider">
                    <div className="carousel-container">
                        <div className="carousel">
                            <div className="carousel-track">
                                {/* START 1 */}
                                <a href="/car-rental" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/car_1.svg" alt="Car Rental Agencies"/>
                                        </figure>
                                        <h3>Car Rental Agencies</h3>
                                        <p>Where rental operators come<br/> for a modern  rental experience</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/car-rental">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>
                                {/* START 2 */}
                                <a href="/car-sharing" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/refresh_1.svg" alt="Car Sharing Hosts"/>
                                        </figure>
                                        <h3>Car Sharing Hosts</h3>
                                        <p>The only direct & private <br/>rental platform for hosts</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/car-sharing">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 3 */}
                                <a href="/ride-sharing" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/user_switch_1.svg" alt="Ride Share Drivers"/>
                                        </figure>
                                        <h3>Ride Share Drivers</h3>
                                        <p>Ride share rentals <br/>made really easy.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/ride-sharing">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 4 */}
                                <a href="/delivery" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/spoon_1.svg" alt="Delivery Drivers"/>
                                        </figure>
                                        <h3>Delivery Drivers</h3>
                                        <p>Expand your business by <br/>renting to gig delivery drivers</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/delivery">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>  
                                </div>
                                </a>

                                {/* START 5 */}
                                <a href="/auto-dealerships" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/parking_1.svg" alt="Auto Dealerships"/>
                                        </figure>
                                        <h3>Auto Dealerships</h3>
                                        <p>Dealership rental software <br/>for the modern customer</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/auto-dealerships">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>  
                                </div>
                                </a>

                                {/* START 6 */}
                                <a href="/service-repair" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/wrench_1.svg" alt="Service & Repair"/>
                                        </figure>
                                        <h3>Service & Repair</h3>
                                        <p>Loaner Cars & Rentals for <br/>Auto Service & Repair Facilities</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/service-repair">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                                </a>

                                {/* START 7 */}
                                <a href="/vacation-rental" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/house_1.svg" alt="Home Rental Hosts"/>
                                        </figure>
                                        <h3>Home Rental Hosts</h3>
                                        <p>Turn Your Rental Home into <br/>the Ultimate Travel Experience</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/vacation-rental">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                                </a>

                                {/* START 8 */}
                                <a href="/hotel-resort" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/hotel_1.svg" alt="Hotel & Resort"/>
                                        </figure>
                                        <h3>Hotel & Resort</h3>
                                        <p>Elevate Your Guest Experience with Seamless Car Rentals</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/hotel-resort">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                                </a>


                                {/* START 9 */}
                                <a href="/property-management" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/property_1.svg" alt="Property Mgmt"/>
                                        </figure>
                                        <h3>Property Mgmt</h3>
                                        <p>Turn your properties into <br/>profit with built-in car rentals.</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/property-management">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                                </a>

                                {/* START 10 */}
                                <a href="/corporate" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/briefcase_1.svg" alt="Corporate"/>
                                        </figure>
                                        <h3>Corporate</h3>
                                        <p>Corporate Rental Fleet <br/>Services Made Easy</p>
                                    </div>
                                     <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/corporate">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 11 */}
                                <a href="/government" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/pentagon_1.svg" alt="Government"/>
                                        </figure>
                                        <h3>Government</h3>
                                        <p>Fleet Rentals for <br/>Government & Municipal</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/government">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div> 
                                </div>
                                </a>

                                {/* START 12 */}
                                <a href="/education" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/education_1.svg" alt="education"/>
                                        </figure>
                                        <h3>Education</h3>
                                        <p>Empowering mobility for students,<br/> staff, and institutions.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/education">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>
                                {/* END */}
                            </div>
                            {/* Duplicated */}
                           
                            <div className="carousel-track">
                                {/* START 1 */}
                                <a href="/car-rental" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/car_1.svg" alt="Car Rental Agencies"/>
                                        </figure>
                                        <h3>Car Rental Agencies</h3>
                                        <p>Where rental operators come<br/> for a modern  rental experience</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 2 */}
                                <a href="/car-sharing" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/refresh_1.svg" alt="Car Sharing Hosts"/>
                                        </figure>
                                        <h3>Car Sharing Hosts</h3>
                                        <p>The only direct & private <br/>rental platform for hosts</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 3 */}
                                <a href="/ride-sharing" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/user_switch_1.svg" alt="Ride Share Drivers"/>
                                        </figure>
                                        <h3>Ride Share Drivers</h3>
                                        <p>Ride share rentals <br/>made really easy.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 4 */}
                                <a href="/delivery" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/spoon_1.svg" alt="Delivery Drivers"/>
                                        </figure>
                                        <h3>Delivery Drivers</h3>
                                        <p>Expand your business by <br/>renting to gig delivery drivers</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 5 */}
                                <a href="/auto-dealerships" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/parking_1.svg" alt="Auto Dealerships"/>
                                        </figure>
                                        <h3>Auto Dealerships</h3>
                                        <p>Dealership rental software <br/>for the modern customer</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 6 */}
                                <a href="/service-repair" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/wrench_1.svg" alt="Service & Repair"/>
                                        </figure>
                                        <h3>Service & Repair</h3>
                                        <p>Loaner Cars & Rentals for <br/>Auto Service & Repair Facilities</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 7 */}
                                <a href="/vacation-rental" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/house_1.svg" alt="Home Rental Hosts"/>
                                        </figure>
                                        <h3>Home Rental Hosts</h3>
                                        <p>Turn Your Rental Home into <br/>the Ultimate Travel Experience</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 8 */}
                                <a href="/hotel-resort" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/hotel_1.svg" alt="Hotel & Resort"/>
                                        </figure>
                                        <h3>Hotel & Resort</h3>
                                        <p>Elevate Your Guest Experience with Seamless Car Rentals</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 9 */}
                                <a href="/property-management" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/property_1.svg" alt="Property Mgmt"/>
                                        </figure>
                                        <h3>Property Mgmt</h3>
                                        <p>Turn your properties into <br/>profit with built-in car rentals.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transWhiteBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 10 */}
                                <a href="/corporate" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/briefcase_1.svg" alt="Corporate"/>
                                        </figure>
                                        <h3>Corporate</h3>
                                        <p>Corporate Rental Fleet <br/>Services Made Easy</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 11 */}
                                <a href="/government" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailBlack">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/pentagon_1.svg" alt="Government"/>
                                        </figure>
                                        <h3>Government</h3>
                                        <p>Fleet Rentals for <br/>Government & Municipal</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_black.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>

                                {/* START 12 */}
                                <a href="/education" className="platformCardLinkWrapper">
                                <div className="platformPageDetail platformPageDetailWhite">
                                    <div className="platformPagedata">
                                        <figure>
                                            <img className="img-fluid" src="/img/Platform/education_1.svg" alt="Education"/>
                                        </figure>
                                        <h3>Education</h3>
                                        <p>Empowering mobility for students,<br/> staff, and institutions.</p>
                                    </div>
                                    <div className="platformPageBtn">
                                        <a className="btn transBlackBtn" href="/">
                                            <span>Learn More</span> 
                                            <img className="img-fluid" src="/img/Platform/arrow_white.svg" alt="Learn More"/>
                                        </a>
                                    </div>
                                </div>
                                </a>
                                {/* END */}
                            </div>
                            {/* Duplicated */}
                        </div>
                    </div>
                </div>
                  

            </section>
            {/* END platformPageSlideMain */}
 

            {/* START firstAndMain */}
            <section className="firstAndMain">
                <div className="firstAndOuter"> 
                    <div className="container">  
                        <div className="firstAndInner"> 
                            <div className='row align-items-center'>
                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                    <div className='firstAndLeft'>
                                        <h2>We’ve embedded everything <br/>you need, all in one place.</h2>
                                        <p>Rental workflows and tools specifically built to reduce operational, administrative 
                                        & logistical headaches for car rental operators.</p>
                                        
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                    <div className='firstAndRight'>
                                        <figure>
                                            <img src="/img/Platform/firstAnd_1.svg" alt="We’ve embedded everything you need, all in one place."/>
                                        </figure>
                                    </div>
                                </div>
                            </div>

                            <div className='row align-items-center'>
                                <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                    <div className='firstAndListing'>
                                        <ul>
                                            <li>
                                                <img src="/img/Pricing/check_green.svg" alt="icon"/>
                                                 Try Rentid for free — no credit card required.
                                            </li>
                                            <li>
                                                <img src="/img/Pricing/check_green.svg" alt="icon"/>
                                                Upgrade or downgrade your plan at any time.
                                            </li>
                                            <li>
                                                <img src="/img/Pricing/check_green.svg" alt="icon"/>
                                                No contracts, no commitment.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            {/* END firstAndMain */}
   
            {/* START toolsWorkflowMain */}
            <section className="toolsWorkflowMain">
                <div className="toolsWorkflowOuter"> 
                    <div className="container">  
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="toolsWorkflowHead">
                                    <h2>Rental Tools & Workflows</h2>
                                    <p>Launch, manage, and scale your business—while maintaining full control over your brand, pricing, and customer relationships.</p>
                                </div>
                            </div>
                        </div>
                        <div className='row toolsWorkRow'>
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='toolsWorkflowInner toolsWorkflowSingle'>
                                    <figure>
                                        <img src="/img/Platform/rent_direct_icon.svg" alt="rent direct"/>
                                    </figure> 
                                    <p>The only all-in-one you’ll ever need</p>
                                    <div className='toolsWorkflowBtn'>
                                        <a className="btn btnWhiteBorder" href="/rentdirect">Learn More</a>
                                        <a className="btn btnWhiteNoBorder" href="/contact-sales">Contact Sales 
                                            <img src="/img/arrow-right-white.svg" alt="Contact Sales"/>
                                        </a>
                                    </div>

                                    <div className="toolsWorkflowImage">
                                        <img className="img-fluid" src="/img/Platform/rent_direct.png" alt="rent direct"/>
                                    </div>
                                </div>
                            </div>
                    
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='toolsWorkflowInner'>
                                    <figure>
                                        <img src="/img/Platform/rent_shield_icon.svg" alt="rent shield"/>
                                    </figure> 
                                    <p>Protection & coverage for every rental</p>
                                    <div className='toolsWorkflowBtn'>
                                        <a className="btn btnWhiteBorder" href="/rentshield">Learn More</a>
                                        <a className="btn btnWhiteNoBorder" href="/contact-sales">Contact Sales 
                                            <img src="/img/arrow-right-white.svg" alt="Contact Sales"/>
                                        </a>
                                    </div>

                                    <div className="toolsWorkflowImage">
                                        <img className="rent_shield_left" src="/img/Platform/primary_comercial.png" alt="Protection & coverage for every rental"/>
                                        <img className="img-fluid" src="/img/Platform/rent_shield.png" alt="rent shield"/>
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='toolsWorkflowInner toolsWorkflowSingle'>
                                    <figure>
                                        <img src="/img/Platform/rent_id_icon.svg" alt="rent id"/>
                                    </figure> 
                                    <p>Trust and safety tools that minimize risk</p>
                                    <div className='toolsWorkflowBtn'>
                                        <a className="btn btnWhiteBorder" href="/rent-id">Learn More</a>
                                        <a className="btn btnWhiteNoBorder" href="/contact-sales">Contact Sales 
                                            <img src="/img/arrow-right-white.svg" alt="Contact Sales"/>
                                        </a>
                                    </div>

                                    <div className="toolsWorkflowImage">
                                        <img className="img-fluid" src="/img/Platform/rent_id.png" alt="rent id"/>
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='toolsWorkflowInner toolsWorkflowSingle'>
                                    <figure>
                                        <img src="/img/Platform/rent_ai_icon.svg" alt="rent ai"/>
                                    </figure> 
                                    <p>AI agents that completes tasks & solves problems</p>
                                    <div className='toolsWorkflowBtn'>
                                        <a className="btn btnWhiteBorder" href="/rentai">Learn More</a>
                                        <a className="btn btnWhiteNoBorder" href="/contact-sales">Contact Sales 
                                            <img src="/img/arrow-right-white.svg" alt="Contact Sales"/>
                                        </a>
                                    </div>

                                    <div className="toolsWorkflowImage">
                                        <img className="img-fluid" src="/img/Platform/rent_ai.png" alt="rent ai"/>
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='toolsWorkflowInner'>
                                    <figure>
                                        <img src="/img/Platform/rent_success_icon.svg" alt="rent success"/>
                                    </figure> 
                                    <p>Support, Resolution Center & Recovery</p>
                                    <div className='toolsWorkflowBtn'>
                                        <a className="btn btnWhiteBorder" href="/rentsuccess">Learn More</a>
                                        <a className="btn btnWhiteNoBorder" href="/contact-sales">Contact Sales 
                                            <img src="/img/arrow-right-white.svg" alt="Contact Sales"/>
                                        </a>
                                    </div>

                                    <div className="toolsWorkflowImage">
                                        <img className="rent_success_left" src="/img/Platform/rent_success_left.png" alt="rent success"/>
                                        <img className="img-fluid" src="/img/Platform/rent_success.png" alt="rent success"/>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='toolsWorkflowInner toolsWorkflowSingle'>
                                    <figure>
                                        <img src="/img/Platform/rent_academy_icon.svg" alt="rent academy"/>
                                    </figure> 
                                    <p>Rental teaching and training hub</p>
                                    <div className='toolsWorkflowBtn'>
                                        <a className="btn btnWhiteBorder" href="/rentacademy">Learn More</a>
                                        <a className="btn btnWhiteNoBorder" href="/contact-sales">Contact Sales 
                                            <img src="/img/arrow-right-white.svg" alt="Contact Sales"/>
                                        </a>
                                    </div>

                                    <div className="toolsWorkflowImage">
                                        <img className="img-fluid" src="/img/Platform/rent_academy.png" alt="rent academy"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END toolsWorkflowMain */}


            {/* START planPlatformMain */}
            <section className='planPlatformMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                
                            <div className='planPlatformInner'>
                                <small>PRICING PLAN</small>
                                <h2>Start for free, then pay only <br/>when your vehicle is rented.</h2>
                                <p>Upgrade to monthly subscription plan to save & earn more.</p>
                                <a className="btn btnDarkPurple" href="/pricing">
                                    <span>View Plans</span>
                                    <img className='img-fluid' src="/img/arrow-right-white.svg" alt="arrow"/>
                                </a>
                                <h5>Try Rentid for free—no credit card required. Upgrade or downgrade <br/>
                                your plan at any time. No contracts, no commitment. All flexibility. </h5>

                                <div className='planPlatformImage'>
                                    <img className='img-fluid' src="/img/Platform/table.png" alt="pricing plan"/>
                                </div>
                            </div>
                
                        </div>
                    </div>
                </div>
            </section>
            {/* END planPlatformMain */}

            {/* STRAT altSolutionsMain */}
            <section className='altSolutionsMain'>
                <div className='altSolutionsOuter'>
                    <div className='container'>
                        {/* row start */}
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="altSolutionsHead">
                                    <h2>Alternative solutions for your business</h2>
                                </div>
                            </div>
                        </div>
                        {/* row end */}


                        {/* row start */}
                        <div className="row justify-content-center">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="altSolutionsInner altSolutionsInner_2">
                                    <a href="/marketplace">
                                        <div className="techHeading">
                                            <h3>Marketplace</h3>
                                        </div>
                                        <div className="altSolutionsData">
                                            <figure>
                                                <img className="img-fluid" src="/img/Technology/map_icon.svg" alt="marketplace"/>
                                            </figure>
                                            <div className="altSolutionsDataRight">
                                                <p>Your rental brand<br/> accessible to renters<br/> anywhere & everywhere.</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="altSolutionsInner altSolutionsInner_3">
                                    <a href="/enterprise">
                                        <div className="techHeading">
                                            <h3>Enterprise</h3>
                                        </div>
                                        <div className="altSolutionsData">
                                            <figure>
                                                <img className="img-fluid" src="/img/Technology/api_icon.svg" alt="rent id"/>
                                            </figure>
                                            <div className="altSolutionsDataRight">
                                                <p>Build with our rental<br/> workflows designed <br/>to scale any business.</p>
                                            </div>
                                        </div>
                                    </a> 
                                </div>
                            </div>
                        </div>
                        {/* row end */}
                    </div>
                </div>
            </section>
            {/* END altSolutionsMain */}


            {/* START expPlatformMain */}
            <section className='expPlatformMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='expPlatformInner'>
                                <h2>Experience the only <br/><span>all-in-one rental platform </span><br/>you'll ever need, period.</h2>
                                <div className='expPlatformBtn'>
                                      {/* <JoinPriorityWaitlistBtn buttonclass="btn btnWhiteSpl" buttonText="Join Waitlist" buttonIcon="/img/arrow_spl.svg" /> */}
                                      {/* <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                /> */}

                            <button onClick={() => setShowWaitlist(true)} className="btn btnWhiteSpl">
                            Join Waitlist <img src='/img/arrow_spl.svg' alt="arrow" />
                            </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END expPlatformMain */}

            <Footer/>
        </>
    )
}

export default Platform;